<template>
  <div class="input-container">
    <input
      ref="checkItem"
      type="checkbox"
      :required="required"
      :name="'radio-' + $parent._uid"
      :id="'option-' + _uid"
      @change="$emit('input', $event.target.checked)"
      @blur="onBlur"
      :value="value"
      :checked="checked"
    />
    <svg
      version="1.1"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      style="enable-background: new 0 0 512 512"
      xml:space="preserve"
    >
      <polygon
        style="fill: #004481"
        points="202.624,478.016 0,291.36 70.512,214.8 191.968,326.656 431.44,33.984 512,99.904 "
      />
    </svg>
    <label :for="'option-' + _uid">{{ label }}</label>
  </div>
</template>

<script>
export default {
  name: "CheckItem",
  props: ["label", "value", "name"],
  replace: false,
  computed: {
    checked() {
      return this.value ? "checked" : "";
    }
  },
  methods: {
    onBlur() {
      // Evento de interacción para GTM
      if (this.name) {
        this.gtmOnCheckboxBlur(this.name, this.checked);
      }
    }
  }
};
</script>

<style scoped>
div.input-container {
  position: relative;
  width: 100%;
}

/* https://stackoverflow.com/questions/26270168/how-to-customize-radio-button-in-html */
input[type="checkbox"] {
  -moz-appearance: none;
  appearance: none;
  /* create custom radiobutton appearance */
  display: inline-block;
  width: 28px;
  height: 28px;
  padding: 5px;
  /* background-color only for content */
  background-clip: content-box;
  background-color: white;
  margin-top: 0px;
  margin-right: 8px;
  margin-bottom: 14px;
  cursor: pointer;
  border-radius: 2px;
  border: solid 2px #c1c1c1;
}

label {
  cursor: pointer;
  position: relative;
  bottom: 21px;
  font-variant: unset;
}

svg {
  display: block;
  position: absolute;
  left: 8px;
  bottom: 22px;
  width: 20px;
  height: 20px;
  pointer-events: none;
  opacity: 0;
  transform: scale(0);
  transition: all 0.2s ease-out;
}

/* appearance for checked radiobutton */
input[type="checkbox"]:focus {
  outline: none;
}

input[type="checkbox"]:checked + label {
  font-family: BentonSansBBVA-Light;
}

input[type="checkbox"]:checked + svg {
  opacity: 1;
  transform: scale(1);
}

#Checkbox1,
#Checkbox2,
#Checkbox3,
#Checkbox4 {
  font-family: BentonSansBBVA-Light;
}
</style>
